import { useEffect, useState } from "react";
import { Bell, BellOff, BellRing } from "lucide-react";
import { toast } from "sonner";
import { enablePush, pushState } from "@/lib/push";
import { useI18n } from "@/i18n/I18nContext";

export const PushPrompt = () => {
  const { t } = useI18n();
  const [state, setState] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    pushState().then(setState).catch(() => setState("unsupported"));
  }, []);
  if (!state || state === "unsupported") return null;
  if (state === "ok") {
    return <p className="flex items-center gap-2 text-xs text-emerald-300" data-testid="push-enabled"><BellRing className="h-4 w-4" /> {t("push.enabled")}</p>;
  }
  if (state === "ios_install") {
    return <p className="flex items-start gap-2 text-xs text-slate-400" data-testid="push-ios-install"><Bell className="mt-0.5 h-4 w-4 shrink-0" /> {t("push.iosInstall")}</p>;
  }
  if (state === "denied") {
    return <p className="flex items-start gap-2 text-xs text-slate-400" data-testid="push-denied"><BellOff className="mt-0.5 h-4 w-4 shrink-0" /> {t("push.denied")}</p>;
  }
  const on = async () => {
    setBusy(true);
    try {
      const r = await enablePush();
      setState(r);
      if (r === "ok") toast.success(t("push.enabled"));
    } catch {
      toast.error(t("push.failed"));
    } finally {
      setBusy(false);
    }
  };
  return (
    <button type="button" onClick={on} disabled={busy} data-testid="push-enable-btn"
      className="flex h-11 w-full items-center justify-center gap-2 rounded-full border border-sky-400/40 text-sm font-semibold text-sky-300 transition-colors hover:bg-sky-400/10 disabled:opacity-60">
      <Bell className="h-4 w-4" /> {t("push.enable")}
    </button>
  );
};
